import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { createUseStyles } from 'react-jss';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { IconCheckCircle } from '@wds/icons';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

const COPY = defineMessages({
  THANK_YOU: {
    id: 'SurveyThanks.EmbeddedNonBranded.ThankYou',
    defaultMessage: 'Thanks for taking this survey.',
    description:
      '[Type: Header][vis: high] - The only message on the webpage. Used on a Nonbranded webpage to say thank you to survey respondents and signal the end of the survey.',
  },
});

const useStyles = createUseStyles((theme: CmsWrenchTheme) => {
  return {
    embeddedContainer: {
      height: theme.util.fullHeight,
      backgroundColor: theme.endpageColors.embeddedNonBranded.backgroundColor,
    },
  };
});

function EmbeddedNonBranded(): React.ReactElement {
  const { embeddedContainer } = useStyles();

  return (
    <Box className={embeddedContainer} display="flex" flexAlign="center" flexJustify="center" flexDirection="column">
      <Box>
        <IconCheckCircle color="primary" size="lg" title="" aria-hidden="true" />
      </Box>
      <Box>
        <Typography color="darkMuted" component="div" variant="body">
          {t(COPY.THANK_YOU)}
        </Typography>
      </Box>
    </Box>
  );
}

export default EmbeddedNonBranded;
